<template>
  <div>
    <div class="ft-22-333 se-m-b-5">我的评价</div>
    <div class="se-list">
      <div
        class="se-item se-p-t-30 se-p-b-30 se-bor-b"
        v-for="(item, index) in evaluateList"
        :key="index"
      >
        <div class="se-flex jcsb">
          <div class="ft-18-333 title">{{ item.name }}</div>
          <div class="se-flex se-m-b-20 title-star">
            <el-rate v-model="item.star" disabled text-color="#ff9900">
            </el-rate>
            <div class="ft-14-999">{{ item.star ? item.star : 0 }}星</div>
          </div>
        </div>
        <!-- se-p-t-20 se-p-b-15 -->
        <div class="ft-14-666 content se-m-b-20">
          <span class="ft-16-yellow se-m-r-10"
            >#{{ item.labels.split(",").join("#") }}</span
          >
          <el-tooltip
            class="item"
            effect="light"
            :content="item.content"
            placement="top"
          >
            <span>{{ item.content }}</span>
          </el-tooltip>
        </div>
        <!-- <div class="ft-12-999">于2021/7/12发表评论</div> -->
        <div class="ft-12-999">于{{ item.evalateTime }}发表评论</div>
      </div>
    </div>
    <div class="se-flex-h-c se-m-t-20">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 3,
      currentPage: 1,
      evaluateList: [], //评价列表
    };
  },
  created() {
    this.getEvaluateList();
  },
  methods: {
    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      this.getEvaluateList();
    },
    //获取我的评价
    getEvaluateList() {
      this.$http
        .get("server/portal/personCenter/myAppraiseList", {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.evaluateList = res.rows;
          this.total = res.total;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.title-star {
  width: 142rpx;
}

.title {
  width: 500px;
  box-sizing: border-box;
  margin-right: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
